import { addressGoogle } from './addressGoogle';
import { attachments } from './attachments';
import { basicInfo } from './basicInfo';
import { birthYear } from './birthYear';
import { companyEmployees } from './companyEmployees';
import { companyName } from './companyName';
import { date } from './date';
import { email } from './email';
import { emergencyDisclaimer } from './emergencyDisclaimer';
import { evaluationInfo } from './evaluationInfo';
import { firstName } from './firstName';
import { forCompaniesPrivacyPolicyAgreement } from './forCompaniesPrivacyPolicyAgreement';
import { forCompaniesTermsConditionsAgreement } from './forCompaniesTermsConditionsAgreement';
import { fullName } from './fullName';
import { hrbAgreements } from './hrbAgreements';
import { hrbOrderQuestionText } from './hrbOrderQuestionText';
import { ico } from './ico';
import { insuranceCompany } from './insuranceCompany';
import { languageSelector } from './languageSelector';
import { lastName } from './lastName';
import { msCenter } from './msCenter';
import { phone } from './phone';
import { preventionInfo } from './preventionInfo';
import { rsAssistantAgreements } from './rsAssistantAgreements';
import { sex } from './sex';
import { time } from './time';
import { updatePassword } from './updatePassword';
import { zipCode } from './zipCode';
import { medicalCategories } from './medicalCategories';

const modules = {
  addressGoogle,
  attachments,
  basicInfo,
  birthYear,
  companyEmployees,
  companyName,
  date,
  email,
  emergencyDisclaimer,
  evaluationInfo,
  firstName,
  forCompaniesPrivacyPolicyAgreement,
  forCompaniesTermsConditionsAgreement,
  fullName,
  hrbAgreements,
  hrbOrderQuestionText,
  ico,
  insuranceCompany,
  languageSelector,
  lastName,
  msCenter,
  phone,
  preventionInfo,
  rsAssistantAgreements,
  sex,
  time,
  updatePassword,
  zipCode,
  medicalCategories
};

// medicalCategories is a public catalogue — skip during reset (refetched on demand).
const RESET_SKIP = new Set(['medicalCategories']);

export const forms = {
  namespaced: true,
  modules,
  actions: {
    // Reset every namespaced child module by committing its `resetStore`
    // mutation. Also reaches dynamically-registered children (e.g. `multifactor`,
    // registered on the account-settings page via `registerModule`) — guarded
    // by a presence check on rootState.forms[name] so we don't commit to a
    // module that isn't mounted.
    resetAll({ commit, rootState }) {
      const formsState = rootState.forms || {};
      Object.keys(formsState).forEach(name => {
        if (RESET_SKIP.has(name)) {
          return;
        }
        commit(`${name}/resetStore`);
      });
    }
  }
};
